export interface IUnit {
  id: number;
  name: string;
  isDeleted?: boolean;
  description?: string;
}
